import { ReactNode, RefObject } from 'react'
import { FieldObject } from '../DocumentEditor/ATSResumeEditor/PersonalDetailsSection/types'
import { Container } from './Styles'
interface Props {
  children: ReactNode | FieldObject
  fullWidth?: boolean
  quarterWidth?: boolean
  elementRef?: RefObject<HTMLDivElement>
}

const EditorField = (props: Props) => {
  const { fullWidth, quarterWidth, children, elementRef, ...rest } = props
  return (
    <Container ref={elementRef} {...{ fullWidth, quarterWidth }} {...rest}>
      {children && typeof children === 'object' && 'value' in children ? children.value : children}
    </Container>
  )
}

export default EditorField
